import AuthReducer from "./Reducer/AuthReducer";
import {applyMiddleware, combineReducers, legacy_createStore} from "redux"
import {thunk} from 'redux-thunk'
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import ProductReducer from "./Reducer/ProductReducer";

const authPersistConfig = {
  key: "auth", // Key to store in localStorage
  storage,     // The storage method (localStorage by default)
};

const persistedAuthReducer = persistReducer(authPersistConfig, AuthReducer);

const rootreducer= combineReducers({
    auth:persistedAuthReducer,
    product:ProductReducer
})

const store= legacy_createStore(rootreducer, applyMiddleware(thunk));

const persistor = persistStore(store);

export  {store,persistor}